import { FaIcon, FaIcons } from "./../fa-icon";
import cn from "clsx";
import React, { forwardRef } from "react";

export interface TogglableChipsProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: string;
  selected?: boolean;
  /**
   * Chip-variants
   * @default "action"
   */
  variant?: "action" | "neutral";
  /**
   * Replaces label read for screen-readers
   * @default "slett filter"
   */
  removeLabel?: string;
  /**
   * Click callback
   */
  onDelete?: () => void;
}

const TogglableChips = forwardRef<HTMLButtonElement, TogglableChipsProps>(
  (
    {
      className,
      children,
      selected,
      variant = "action",
      removeLabel = "slett",
      onDelete,
      type = "button",
      ...rest
    },
    ref
  ) => {
    return (
      <button
        {...rest}
        ref={ref}
        type={type}
        className={cn("in-chips__chip in-chips__togglable", className)}
        aria-label={`${children} ${removeLabel}`}
        aria-pressed={selected}
      >
        {selected ? (
          <FaIcon name={FaIcons.CircleCheckRegular} />
        ) : (
          <FaIcon name={FaIcons.CircleRegular} />
        )}
        <span className="in-chips__chip-text">{children}</span>
      </button>
    );
  }
);

export { TogglableChips };
